/* eslint-disable camelcase */
import React from "react";
import PropTypes from "prop-types";
import useBelowBreakpoint from "core-web/hooks/useBelowBreakpoint";
import { headingObjectProp } from "core-web/utils/proptypes/modules/textProps";
import transformHeadingGroup from "theme/libs/wordpress/utils/transformHeadingGroup";
import TextHero from "theme/components/contentBlocks/TextHero";
import activeSetting from "theme/libs/wordpress/utils/activeSetting";

// Pure CMS data transformation before we send it to the "real" block!
const TextHeroBlock = ({ content }) => {
    if (!content) {
        return null;
    }

    const isMobile = useBelowBreakpoint("tabletLg");
    const device = isMobile ? "mobile" : "desktop";
    const { heading, paragraph, link, settings: activeSettings } = content?.data || {};
    const { text: headingText } = transformHeadingGroup(heading, device);

    return (
        <TextHero
            heading={activeSetting(activeSettings, "heading") && headingText}
            paragraph={(activeSetting(activeSettings, "paragraph") && paragraph) || []}
            link={activeSetting(activeSettings, "link") && link}
        />
    );
};

TextHeroBlock.propTypes = {
    content: PropTypes.shape({
        heading: headingObjectProp,
        description: PropTypes.string,
    }),
};

export default TextHeroBlock;
